import LayoutPure from './pure';

const Layout = LayoutPure;

export default Layout;